import { defineComponent as _defineComponent } from 'vue'
import CcCard from '@/views/Automation/CampaignCreatorV2/components/CcCard/CcCard.ts.vue';
import CcCardItem from '@/views/Automation/CampaignCreatorV2/components/CcCard/CcCardItem.ts.vue';
import CcCheckbox from '@/views/Automation/CampaignCreatorV2/components/CcCheckbox/CcCheckbox.ts.vue';
import CcError from '@/views/Automation/CampaignCreatorV2/components/CcError/CcError.ts.vue';
import CcBuildUrlParameterModal from '@/views/Automation/CampaignCreatorV2/components/Modals/CcBuildUrlParameterModal.ts.vue';
import TreeselectAccountOption from '@/views/Automation/CampaignCreatorV2/components/Treeselect/TreeselectAccountOption.ts.vue';
import useAdAccountStore from '@/views/Automation/CampaignCreatorV2/store/AdAccount';
import useCreativeStore from '@/views/Automation/CampaignCreatorV2/store/Creative';
import { CardLayer, TreeselectOptionAdAccount } from '@/views/Automation/CampaignCreatorV2/types';
import Treeselect from '@riophae/vue-treeselect';
import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Tracking.ts',
  setup(__props) {

const adAccountStore = useAdAccountStore();
const { getPixelsOptions } = storeToRefs(adAccountStore);
const creativeStore = useCreativeStore();
const creativeGetters = storeToRefs(creativeStore);

const buildUrlParameterModal = ref<NullableType<InstanceType<typeof CcBuildUrlParameterModal>>>(null);
const websiteEvent = ref(true);

const creativePixelId = creativeGetters.getField.value('pixel_id');

const urlTags = computed(() => creativeGetters.getField.value('url_tags')?.value?.[0] || {});

const pixelOptions = computed((): TreeselectOptionAdAccount[] =>
  getPixelsOptions.value?.map(
    (p): TreeselectOptionAdAccount => ({
      id: p.id,
      label: p.name,
      info: p.id,
      isActive: true,
      isDisabled: p.id === 'loading',
    })
  )
);

function onUrlModalOpen() {
  buildUrlParameterModal.value?.onModalOpen();
}
function onUrlTagChange(value: string) {
  creativeStore.addOrEditVariable('url_tags', { field: 'url_tags', value, variableId: 'url_tags' });
}
function onWebsiteEventChange(value: boolean) {
  console.log('Tracking.ts.vue / onWebsiteEventChange', value);
}
function onPixelChange(value: { id: string }) {
  creativeStore.addOrEditVariable('pixel_id', {
    field: 'pixel_id',
    value: value.id,
    variableId: creativePixelId?.value?.[0]?.variableId!,
  });
}

return { __sfc: true,adAccountStore, getPixelsOptions, creativeStore, creativeGetters, buildUrlParameterModal, websiteEvent, creativePixelId, urlTags, pixelOptions, onUrlModalOpen, onUrlTagChange, onWebsiteEventChange, onPixelChange, CcCard, CcCardItem, CcCheckbox, CcError, CcBuildUrlParameterModal, TreeselectAccountOption, CardLayer, Treeselect }
}

})